import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import { Link } from 'react-router-dom';

const faqData = [
  {
    question: '风车动漫的动漫资源是否需要付费？',
    answer: '风车动漫所有动漫资源均为免费在线观看，无需付费或订阅。我们致力于为广大动漫爱好者提供最便捷的观看体验。',
  },
  {
    question: '动漫视频的画质如何？支持哪些清晰度？',
    answer: '我们提供从标清到超清多种画质选择，包括720P、1080P等，部分热门动漫支持4K超清画质，您可以根据网络情况自由切换。',
  },
  {
    question: '可以在手机上观看吗？',
    answer: '当然可以！风车动漫网站完全支持移动端访问，您可以在手机、平板等设备上流畅观看。页面会自适应屏幕大小，确保最佳观看体验。',
  },
  {
    question: '更新频率是怎样的？',
    answer: '我们会在动漫新剧集发布后第一时间更新，通常24小时内即可上线。热门连载动漫更是做到同步更新，让您不错过每一集。',
  },
  {
    question: '如何搜索想看的动漫？',
    answer: '您可以通过网站顶部的搜索框输入动漫名称进行搜索，也可以通过分类页面按类别浏览喜欢的动漫作品。',
  },
];

const testimonials = [
  {
    name: '小明',
    role: '动漫爱好者',
    content: '风车动漫真的太棒了！资源全、画质好，而且完全免费。自从发现了这个网站，我就再也没有去过其他动漫网站了。',
    rating: 5,
  },
  {
    name: '花花',
    role: '大学生',
    content: '界面简洁好看，分类也很清晰。最让我喜欢的是可以一口气看完整部动漫，不用等更新，追番体验满分！',
    rating: 5,
  },
  {
    name: '阿杰',
    role: '程序员',
    content: '作为一个看了十几年动漫的老粉，风车动漫是我见过资源最全的中文动漫站。推荐给所有动漫爱好者。',
    rating: 5,
  },
  {
    name: '小美',
    role: '设计师',
    content: '网站的UI设计很有品味，没有乱七八糟的广告弹窗，看动漫的体验非常纯净。更新速度也很快，点赞！',
    rating: 5,
  },
];

export default function AboutPage() {
  const orgJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '风车动漫',
    url: 'https://www.fengchedongman.com',
    description: '风车动漫网支持在线观看全集动漫，从开头到结局连续播放，无需等待更新，满足用户一口气看完整个系列的需求。',
    contactPoint: {
      '@type': 'ContactPoint',
      email: 'contact@fengchedongman.com',
      contactType: 'customer service',
      availableLanguage: ['Chinese'],
    },
  };

  const faqJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqData.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  };

  const breadcrumbJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: '首页', item: 'https://www.fengchedongman.com/' },
      { '@type': 'ListItem', position: 2, name: '关于我们', item: 'https://www.fengchedongman.com/about' },
    ],
  };

  return (
    <>
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(orgJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(faqJsonLd) }}
      />
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{ __html: JSON.stringify(breadcrumbJsonLd) }}
      />
      <Navbar />
      <main className="pt-20">
        <div className="px-4 md:px-6 py-8">
          <div className="max-w-6xl mx-auto">
            <nav className="flex items-center gap-2 text-sm text-foreground-500 mb-6">
              <Link to="/" className="hover:text-primary-500 transition-colors">首页</Link>
              <i className="ri-arrow-right-s-line text-xs"></i>
              <span className="text-foreground-700 font-medium">关于我们</span>
            </nav>

            <section className="mb-16">
              <h1 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">关于风车动漫</h1>
              <p className="text-foreground-600 leading-relaxed max-w-3xl text-sm md:text-base">
                风车动漫是一个专注动漫在线观看的中文平台。我们的使命是让每一位动漫爱好者都能轻松找到并观看自己喜欢的动漫作品。
                不同于需要等待周更的传统追番模式，风车动漫致力于提供<strong>全集动漫资源</strong>，让用户从开头到结局连续播放，
                无需等待更新，满足用户一口气看完整个系列的需求。
              </p>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-6">我们的优势</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                {[
                  { icon: 'ri-movie-line', title: '海量资源', desc: '收录数万部国内外动漫作品，涵盖热血、搞笑、恋爱、奇幻、悬疑等多种类型' },
                  { icon: 'ri-speed-up-line', title: '更新迅速', desc: '新番上线后24小时内更新，热门连载同步跟进，不错过任何精彩内容' },
                  { icon: 'ri-hd-line', title: '高清画质', desc: '支持720P至4K多种清晰度选择，自适应网络环境，确保流畅观看体验' },
                  { icon: 'ri-smartphone-line', title: '多端适配', desc: '完美适配电脑、平板、手机等多种设备，随时随地享受动漫乐趣' },
                  { icon: 'ri-shield-check-line', title: '安全纯净', desc: '无恶意广告弹窗，纯净的观看环境，保护您的设备和隐私安全' },
                  { icon: 'ri-user-heart-line', title: '完全免费', desc: '所有动漫资源永久免费，无需注册、无需付费，真正零门槛观看' },
                ].map((item) => (
                  <div key={item.title} className="p-5 rounded-lg bg-background-50 border border-background-200/70">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3">
                      <i className={`${item.icon} text-lg`}></i>
                    </div>
                    <h3 className="font-heading text-base text-foreground-900 mb-1">{item.title}</h3>
                    <p className="text-xs text-foreground-500 leading-relaxed">{item.desc}</p>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-6">用户口碑</h2>
              <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
                {testimonials.map((item) => (
                  <div key={item.name} className="p-5 rounded-lg bg-background-100 border border-background-200/70">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: item.rating }, (_, i) => (
                        <i key={i} className="ri-star-fill text-accent-400 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-600 leading-relaxed mb-4">{item.content}</p>
                    <div>
                      <p className="text-sm font-medium text-foreground-900">{item.name}</p>
                      <p className="text-xs text-foreground-400">{item.role}</p>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-6">常见问题</h2>
              <div className="max-w-3xl space-y-3">
                {faqData.map((item, index) => (
                  <details key={index} className="group rounded-lg bg-background-50 border border-background-200/70">
                    <summary className="flex items-center justify-between px-5 py-4 cursor-pointer">
                      <span className="text-sm font-medium text-foreground-800">{item.question}</span>
                      <i className="ri-arrow-down-s-line text-foreground-400 group-open:rotate-180 transition-transform"></i>
                    </summary>
                    <div className="px-5 pb-4">
                      <p className="text-sm text-foreground-500 leading-relaxed">{item.answer}</p>
                    </div>
                  </details>
                ))}
              </div>
            </section>

            <section className="mb-16">
              <h2 className="font-heading text-xl md:text-2xl text-foreground-900 mb-6">联系我们</h2>
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div className="space-y-4">
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-500 flex-shrink-0">
                      <i className="ri-mail-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">电子邮箱</p>
                      <p className="text-sm text-foreground-500">contact@fengchedongman.com</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 flex-shrink-0">
                      <i className="ri-qq-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">客服QQ</p>
                      <p className="text-sm text-foreground-500">1234567890</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-3">
                    <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600 flex-shrink-0">
                      <i className="ri-time-line text-lg"></i>
                    </div>
                    <div>
                      <p className="text-sm font-medium text-foreground-800">工作时间</p>
                      <p className="text-sm text-foreground-500">周一至周五 9:00 - 18:00</p>
                    </div>
                  </div>
                </div>
                <div className="p-6 rounded-lg bg-background-100 border border-background-200/70">
                  <h3 className="font-heading text-base text-foreground-900 mb-4">发送消息</h3>
                  <form
                    data-readdy-form="true"
                    action="#"
                    method="POST"
                    className="space-y-4"
                    onSubmit={(e) => {
                      e.preventDefault();
                      alert('消息已发送！我们会尽快回复您。');
                    }}
                  >
                    <input
                      type="text"
                      name="name"
                      placeholder="您的姓名"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-700 outline-none focus:border-primary-300 transition-colors"
                      required
                    />
                    <input
                      type="email"
                      name="email"
                      placeholder="您的邮箱"
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-700 outline-none focus:border-primary-300 transition-colors"
                      required
                    />
                    <textarea
                      name="message"
                      placeholder="请输入您的留言..."
                      rows={4}
                      maxLength={500}
                      className="w-full px-4 py-2.5 rounded-lg border border-background-200 bg-background-50 text-sm text-foreground-700 outline-none focus:border-primary-300 transition-colors resize-none"
                      required
                    ></textarea>
                    <input
                      type="text"
                      name="website_alt"
                      className="honeypot-field"
                      tabIndex={-1}
                      autoComplete="off"
                      aria-hidden="true"
                      readOnly
                    />
                    <button
                      type="submit"
                      className="w-full px-6 py-2.5 bg-primary-500 hover:bg-primary-600 text-white rounded-lg text-sm font-medium transition-colors whitespace-nowrap cursor-pointer"
                    >
                      发送消息
                    </button>
                  </form>
                </div>
              </div>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}